import { RenderClearFlag } from "../../RenderEngine/RenderEnum/RenderClearFlag";
import { Vector4 } from "../../maths/Vector4";
import { Viewport } from "../../maths/Viewport";
export class RenderPassUtil {
    static renderCmd(cmds, context) {
        if (cmds && cmds.length > 0)
            cmds.forEach(value => context.runCMDList(value._renderCMDs));
    }
    static recoverRenderContext3D(context, renderTarget) {
        context.setViewPort(this.contextViewPortCache);
        context.setScissor(this.contextScissorCache);
        context.setRenderTarget(renderTarget, RenderClearFlag.Nothing);
    }
}
RenderPassUtil.contextViewPortCache = new Viewport();
RenderPassUtil.contextScissorCache = new Vector4();
